module.exports = __webpack_public_path__ + "static/img/9.6cfa0cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/9.jpg
// module id = zTMG
// module chunks = 26